/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { addpricing } from "../../redux/actions/frontendActions/pricingAction";
import Dashboard_top_header from "../utils/Dashboard_top_header";
import Sidebar from "../utils/Sidebar";
const pricingState = {
  title: "",
  price: 0,
  grade: "",
  categories: "",
  description:"",
  features: [],
  color:""
};

function DashboardAddPricing() {
  const {loader,pricingSuccessMessage,pricingErrorMessage}= useSelector(state =>state.Pricing);
  

  const dispatch = useDispatch()
  const [state, setState] = useState(pricingState);
  const [sidebarHide, setSidebarHide] = useState(false);
  const [tags, setTags] = useState([]);
  const handleSidebarHideAndShow = (e) => {
    setSidebarHide(!sidebarHide);
  };
  // handle input
  const handleInput = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // handle tags
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;
    const value = e.target.value;
    if (!value.trim()) return;
    setTags([...tags, value]);
    setState({
      ...state,
      features: tags,
    });
    e.target.value = "";
  };

  const removeTag = (index) => {
    setTags(tags.filter((el, i) => i !== index));
    setState({
      ...state,
      features: tags,
    });
  };

  
  // handle main form

  const handleForm = (e) => {
    e.preventDefault();
    dispatch(addpricing(state))
   
  };

  useEffect(() => {
    if (pricingSuccessMessage) {
      window.location.href = "/admin/dashboard/all-pricing";
    }
  }, [pricingSuccessMessage ,pricingErrorMessage]);


  return (
    <div className="dashboard-container">
      <div className="navbar-area">
        <Dashboard_top_header
          handleSidebarHideAndShow={handleSidebarHideAndShow}
          sidebarHide={sidebarHide}
        />
      </div>

      <div className="dashboard-main-flex">
        <div className="dashboard-sidebar">
          <Sidebar sidebarHide={sidebarHide} />
        </div>
        <div className="dashboard-item">
          {/* add pricing  */}

          <div className="dashboard-add-portfolio-wrapper">
            <div className="form-box">
              <h2>Add Pricings</h2>
              <form onSubmit={handleForm}>
                <div className="input-flex">
                  <div className="form-group">
                    <input
                      onChange={handleInput}
                      type="text"
                      placeholder="Project title"
                      name="title"
                      className="form-control"
                    />
                  </div>

                  <div className="form-group">
                    <input
                      onChange={handleInput}
                      type="number"
                      placeholder="$ price"
                      name="price"
                      className="form-control"
                    />
                  </div>
                </div>

                {/* categories  */}
                <div className="form-group">
                  <select
                    onChange={handleInput}
                    name="categories"
                    className="form-control"
                  >
                    <option value="#">Select categories</option>
                    <option value="frontend">Frontend</option>
                    <option value="fullstack">Full Stack</option>
                    <option value="wordpress">Wordpress</option>
                    <option value="woocommerce">WooCommerce</option>
                    <option value="landing">Landing page</option>
                  </select>
                </div>

                <div className="form-group">
                  <textarea
                    onChange={handleInput}
                    type="text"
                    placeholder="Description "
                    name="description"
                    className="form-control"
             
                  />
                </div>

                <div className="form-group">
                  <select
                    onChange={handleInput}
                    name="grade"
                    className="form-control"
                  >
                    <option value="#">Select grade</option>
                    <option value="starter">Starter</option>
                    <option value="popular">Most popular</option>
                    <option value="business">Business</option>
                  </select>
                </div>

                {/* tags  */}
                <div className="form-group">
                  <div className="tag-input-container  feature">
                    {tags.map((tag, index) => (
                      <div className="tag-item" key={index}>
                        <span className="text">{tag}</span>
                        <span
                          onClick={() => removeTag(index)}
                          className="close"
                        >
                          <FaTimes size={15} />
                        </span>
                      </div>
                    ))}

                    <input
                      onChange={handleInput}
                      onKeyDown={handleKeyDown}
                      type="text"
                      className="tags-input"
                      placeholder="add pricing features...."
                    />
                  </div>
                </div>


                <label style={{paddingLeft:"15px"}} htmlFor="#">Colour select</label> <br />
                <div className="form-group color-select">
                
                <div className="radio-input-flex">
                    <div>
                      {" "}
                      <input

                        type="radio"
                        value="white"
                         onChange={handleInput}
                        className="radio-input"
                        name="color"
                        id="white"
                      />{" "}
                    </div>
                    <div>
                      {" "}
                      <label htmlFor="white">White</label>
                    </div>
                  </div>
          

                 

                  <div className="radio-input-flex">
                    <div>
                      {" "}
                      <input
                        type="radio"
                         onChange={handleInput}
                        className="radio-input"
                        name="color"
                        id="purple"
                        value="purple"
                      />
                    </div>
                    <div>
                      {" "}
                      <label htmlFor="purple">Purple</label>
                    </div>
                  </div>
                </div>

                {
                    pricingErrorMessage &&

                     <div className="form-group error-area">
                  
               {
                pricingErrorMessage.map((err, index) => <p key={index}>{err}</p>)
               }
                  
                </div>
                }

                <div className="form-group button-area">
                  <div className="image"></div>
                  <button type="submit">{loader ? "Creating Pricing": "Add Pricing"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardAddPricing;
